import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';



@Component({
  selector: 'app-no-data-jumbotron',
  templateUrl: './no-data-jumbotron.component.html',
  host: {
    'class': 'd-flex flex-column align-items-center justify-content-center w-100 h-100 py-5 text-center'
  }
})
export class NoDataJumbotronComponent {
  @Input()
  set hasFilters(value: any) {
    this._hasFilters = coerceBooleanProperty(value);
  }
  get hasFilters(): boolean {
    return this._hasFilters;
  }

  private _hasFilters: boolean = false;
}
